module.exports = __webpack_public_path__ + "static/pro-84b94cc1c82c0645f4039bbb657c9a0d.png";